import { test } from '@playwright/test';
import { onFormSubmitCallback } from '../playwright-util/form';
import { expect } from '../playwright-util/custom-matchers';

test.describe('checkbox-component', () => {
	test.beforeEach(async ({ page }) => {
		await page.goto('iframe.html?viewMode=docs&id=test-checkbox--docs');
	});

	test('visibility', async ({ page }) => {
		await expect(page.locator('#with-label')).toBeVisible();
		await expect(page.locator('#unchecked')).toBeVisible();
		await expect(page.locator('#checked')).toBeVisible();
		await expect(page.locator('#custom-value')).toBeVisible();
		await expect(page.locator('#disabled')).toBeVisible();
		await expect(page.locator('#checked-disabled')).toBeVisible();
	});

	test('states', async ({ page }) => {
		const checkboxWithLabel = page.locator('#with-label');
		await expect(checkboxWithLabel).isNotChecked();

		const uncheckedCheckbox = page.locator('#unchecked');
		await expect(uncheckedCheckbox).isNotChecked();

		const checkedCheckbox = page.locator('#checked');
		await expect(checkedCheckbox).isChecked();

		const disabledCheckbox = page.locator('#disabled');
		await expect(disabledCheckbox).toHaveAttribute('disabled', '');

		const checkedDisabledCheckbox = page.locator('#checked-disabled');
		await expect(checkedDisabledCheckbox).isChecked();
		await expect(checkedDisabledCheckbox).toHaveAttribute('disabled', '');
	});

	test('interaction', async ({ page }) => {
		await page.getByLabel('Checkbox with label').click();
		const checkboxWithLabel = page.locator('#with-label');
		await expect(checkboxWithLabel).isChecked();

		const uncheckedCheckbox = page.locator('#unchecked');
		await uncheckedCheckbox.click();
		await expect(uncheckedCheckbox).isChecked();

		const checkedCheckbox = page.locator('#checked');
		await checkedCheckbox.click();
		await expect(checkedCheckbox).isNotChecked();

		const disabledCheckbox = page.locator('#disabled');
		await disabledCheckbox.click();
		await expect(checkedCheckbox).isNotChecked();

		const checkedDisabledCheckbox = page.locator('#checked-disabled');
		await checkedDisabledCheckbox.click();
		await expect(checkedDisabledCheckbox).isChecked();
	});

	test('form-submission', async ({ page }) => {
		const getFormData = await onFormSubmitCallback(page, 'checkbox-form');

		const checkboxGroupMember = page.locator('#group-member-1');
		await checkboxGroupMember.click();

		const checkboxGroupMember2 = page.locator('#group-member-2');
		await checkboxGroupMember2.click();

		const checkboxGroupMember3 = page.locator('#group-member-3');
		await checkboxGroupMember3.click();

		await page.locator('#submit-button').click();

		await expect.poll(async () => (await getFormData()) !== null, 'Form data not received').toBeTruthy();
		const formData = await getFormData();

		expect(formData).toMatchObject({
			checked: 'on',
			'custom-value': 'custom-value',
			'checkbox-group': ['option-1', 'option-2', 'option-3'],
		});
		expect(formData).not.toHaveProperty('unchecked');
		expect(formData).not.toHaveProperty('disabled');
		expect(formData).not.toHaveProperty('checked-disabled');
	});

	test('form-reset', async ({ page }) => {
		await page.locator('#unchecked').click();
		await page.locator('#checked').click();

		await page.locator('#reset-button').click();

		await expect(page.locator('#unchecked')).isNotChecked();
		await expect(page.locator('#checked')).isChecked();
	});
});
